




import { Component, Mixins } from 'vue-property-decorator';
import GlobalOverlayMethods from '@/mixins/GlobalOverlayMethods.vue';

@Component({
    name: 'GlobalOverlayCloseButton',
})
export default class GlobalOverlayCloseButton extends Mixins(
    GlobalOverlayMethods,
) {
    constructor() {
        super();
    }
}
